import { render, staticRenderFns } from "./AbkVideoSectionForm.vue?vue&type=template&id=3949c8fa&scoped=true&"
import script from "./AbkVideoSectionForm.vue?vue&type=script&lang=js&"
export * from "./AbkVideoSectionForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkVideoSectionForm.vue?vue&type=style&index=0&id=3949c8fa&scoped=true&lang=scss&"
import style1 from "./AbkVideoSectionForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3949c8fa",
  null
  
)

export default component.exports